(ns frontend.view.entity-merge.guests
  (:require [common.entity :as entity]
            [common.localization :as loc]
            [common.util :as cu]
            [frontend.state.current-session :as session]
            [frontend.utils :as fu]
            [frontend.view.entity-merge.components :as components]
            [frontend.view.entity-merge.events :as events]
            [frontend.view.task.webentry-resolution.components :as we]))

(defmethod components/step-info :guests [{:keys [entity-type] :as signals} [step-kw _step-params]]
  (loc/tr :merge-select-guests))

(defn review [{:keys [state r-target r-source] :as signals}]
  (let [rejection-path [:rejection :guests]
        rejection (get-in @state rejection-path)
        source-guest-roles (->> @session/roles
                                (cu/filter-by :role/target (:db/id @r-source)))
        source-guest-accounts (->> source-guest-roles
                                   (keep :role/subject)
                                   (keep session/get-entity))
        target-guest-roles (->> @session/roles
                                (cu/filter-by :role/target (:db/id @r-target)))
        target-guest-accounts (->> target-guest-roles
                                   (keep :role/subject)
                                   (keep session/get-entity))
        selected-guest-accounts (->> target-guest-accounts
                                     (concat source-guest-accounts)
                                     (remove (fn [{:keys [db/id]}]
                                               (contains? rejection id)))
                                     distinct)

        target-attachments (->> @r-target
                                :common/attachments
                                (keep events/get-entity))
        source-attachments (->> @r-source
                                :common/attachments
                                (keep events/get-entity))
        selected-attachments (->> target-attachments
                                  (concat source-attachments)
                                  (remove (fn [{:keys [db/id]}]
                                            (contains? rejection id)))
                                  distinct)]
    [components/review-card signals
     {:title (loc/tr :guest-accounts)
      :collapsed-path [:review-guests]
      :content
      [:div
       (doall
        (for [{:keys [db/id] :as guest-account} selected-guest-accounts]
          ^{:key (str "guest-" id)}
          [:div.mb-3
           (entity/display-string guest-account :long)]))]}]))

(defn guests-list [{:keys [guest-accounts rejection toggle!]}]
  [:<>
   (doall
    (for [{:keys [db/id account/email] :as guest-account} guest-accounts
          :let [selected? (not (contains? rejection id))]]
      ^{:key (str "guest-" id)}
      [:div
       {:class-name (fu/cs "asset-updater-table__current-value mb-2"
                           (when selected?
                             "selected"))
        :on-click (fn [_]
                    (toggle! id))}
       (if selected?
         [:i.fas.fa-check-circle.mr-2]
         [:i.fal.fa-circle.mr-2])
       [:div
        [:div (entity/display-string guest-account :long)]]]))])

(defn view [{:keys [state r-source r-target] :as signals}]
  (let [rejection-path [:rejection :guests]
        toggle-guest! (partial events/toggle! state rejection-path)]
    (fn [{:keys [r-source-id r-target-id] :as signals}]
      (let [source-guest-roles (->> @session/roles
                                    (cu/filter-by :role/target @r-source-id))
            source-guest-accounts (->> source-guest-roles
                                       (keep :role/subject)
                                       (keep session/get-entity))
            target-guest-roles (->> @session/roles
                                    (cu/filter-by :role/target @r-target-id))
            target-guest-accounts (->> target-guest-roles
                                       (keep :role/subject)
                                       (keep session/get-entity))
            rejection (get-in @state rejection-path)]
        [:div.asset-updater-table__fields
         [:div.asset-updater-table__field
          [:div.asset-updater-table__compare
           [:div
            {:class-name "mt-4 grid grid-cols-2 gap-4"}
            [:div
             [guests-list {:guest-accounts source-guest-accounts
                           :rejection rejection
                           :toggle! toggle-guest!}]]

            [:div
             [guests-list {:guest-accounts target-guest-accounts
                           :rejection rejection
                           :toggle! toggle-guest!}]]]]]]))))
